import { actionTypes } from 'app/types/action_types';
import { InspirePage } from '../../types/inspirePageTypes';

const initialState: InspirePage = { dataSchema: {} };

const mapPayload = (payload): InspirePage => {
  if (Object.keys(payload).length === 0) return initialState;

  return {
    blogAssets: payload.blogAssets,
    breadCrumbs: payload.breadCrumbs,
    dataSchema: payload.dataSchema,
    heroImage: payload.heroImage,
    pageInfo: payload.pageInfo,
    taxonomyData: payload.taxonomyData,
    signatureCollection: payload.signatureCollection,
    mostPopular: payload.mostPopular,
    experiences: payload.experiences,
  };
};

// eslint-disable-next-line default-param-last
const inspirePageReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapPayload(action.payload);
    default:
      return state;
  }
};

export default inspirePageReducer;
